import {pointerUtils, type CreateExtArgs} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import {getComponentType} from '../../../utils/dalUtils'
import type {LoggerExtAPI} from '../../logger'
import {COMP_IDS, COMP_TYPES, MASTER_PAGE_ID} from '../../../constants/constants'
import {isPopup} from '../../page/popupUtils'
import type {ValidationResult} from './types'

export const validateComponentToDelete = (
    createExtArgs: CreateExtArgs,
    compPtr: Pointer,
    deletedFromFull?: boolean
): ValidationResult => {
    const {dal, pointers} = createExtArgs
    const {logger} = createExtArgs.extensionAPI as LoggerExtAPI

    if (compPtr.id === MASTER_PAGE_ID) {
        logger.breadcrumb('cannot delete master page')
        return {success: false, error: 'cannot delete master page'}
    }

    const compType = getComponentType(dal, compPtr)
    const typePointer = pointerUtils.getInnerPointer(compPtr, 'type')
    const type = dal.get(typePointer)

    if (!compType) {
        logger.breadcrumb('component does not have type', {extras: {componentPointer: compPtr}})
        return {success: false, error: 'component does not have type'}
    }

    if (type === 'Page') {
        if (isPopup(createExtArgs, compPtr.id)) {
            return {success: true}
        }
        const pagesPointers = pointers.page.getNonDeletedPagesPointers(false)
        if (pagesPointers.length === 1) {
            logger.breadcrumb('site must have at least one page', {extras: {componentPointer: compPtr}})
            return {success: false, error: 'site must have at least one page'}
        }
        return {success: true}
    }

    if (compPtr.id === COMP_IDS.HEADER && compType === COMP_TYPES.HEADER_CONTAINER) {
        logger.breadcrumb('cannot delete header component', {extras: {componentPointer: compPtr, compType}})
        return {success: false, error: 'cannot delete header component'}
    }

    if (compPtr.id === COMP_IDS.FOOTER && compType === COMP_TYPES.FOOTER_CONTAINER) {
        logger.breadcrumb('cannot delete footer component', {extras: {componentPointer: compPtr, compType}})
        return {success: false, error: 'cannot delete footer component'}
    }

    if (!deletedFromFull && !dal.has(compPtr)) {
        logger.breadcrumb('component param does not exist', {extras: {componentPointer: compPtr}})
        return {success: false, error: 'component param does not exist'}
    }

    return {success: true}
}
